<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
<component v-bind:is="component"/>
</template>

<script>
import { _startcase } from '@/config/util';
import Admin from '@/assets/svg/ico-admin.svg';
import Agent from '@/assets/svg/ico-agent.svg';
import AngleDown from '@/assets/svg/ico-angle-down.svg';
import ArchiveBorder from '@/assets/svg/ico-archive-border.svg';
import ArchiveFilled from '@/assets/svg/ico-archive-filled.svg';
import Arhive from '@/assets/svg/ico-arhive.svg';
import ArrowDown from '@/assets/svg/ico-arrow-down.svg';
import ArrowL from '@/assets/svg/ico-arrow-l.svg';
import ArrowLeft from '@/assets/svg/ico-arrow-left.svg';
import ArrowRight from '@/assets/svg/ico-arrow-right.svg';
import ArrowUp from '@/assets/svg/ico-arrow-up.svg';
import Bell from '@/assets/svg/ico-bell.svg';
import Building from '@/assets/svg/ico-building.svg';
import Buildings from '@/assets/svg/ico-buildings.svg';
import CalendarDays from '@/assets/svg/ico-calendar-days.svg';
import Calendar from '@/assets/svg/ico-calendar.svg';
import Checked from '@/assets/svg/ico-checked.svg';
import ChevronDown from '@/assets/svg/ico-chevron-down.svg';
import CircleDollar from '@/assets/svg/ico-circle-dollar.svg';
import ClipboardList from '@/assets/svg/ico-clipboard-list.svg';
import CloseIcon from '@/assets/svg/ico-close-icon.svg';
import CloseSm from '@/assets/svg/ico-close-sm.svg';
import Close from '@/assets/svg/ico-close.svg';
import Cog from '@/assets/svg/ico-cog.svg';
import Commercial from '@/assets/svg/ico-commercial.svg';
import Copy from '@/assets/svg/ico-copy.svg';
import Customers from '@/assets/svg/ico-customers.svg';
import Delete from '@/assets/svg/ico-delete.svg';
import Dolar from '@/assets/svg/ico-dolar.svg';
import DollarSign from '@/assets/svg/ico-dollar-sign.svg';
import Dots from '@/assets/svg/ico-dots.svg';
import Edit from '@/assets/svg/ico-edit.svg';
import Ellipsis from '@/assets/svg/ico-ellipsis.svg';
import Email from '@/assets/svg/ico-email.svg';
import ExclamationCircle from '@/assets/svg/ico-exclamation-circle.svg';
import ExclamationLight from '@/assets/svg/ico-exclamation-light.svg';
import ExclamationMark from '@/assets/svg/ico-exclamation-mark.svg';
import ExclamationRegular from '@/assets/svg/ico-exclamation-regular.svg';
import Exclamation from '@/assets/svg/ico-exclamation.svg';
import Eye from '@/assets/svg/ico-eye.svg';
import Eyeslash from '@/assets/svg/ico-eyeslash.svg';
import File from '@/assets/svg/ico-file.svg';
import Filters from '@/assets/svg/ico-filters.svg';
import Gallery from '@/assets/svg/ico-gallery.svg';
import Grid from '@/assets/svg/ico-grid.svg';
import Happy from '@/assets/svg/ico-happy.svg';
import Home from '@/assets/svg/ico-home.svg';
import ImgBig from '@/assets/svg/ico-img-big.svg';
import Img from '@/assets/svg/ico-img.svg';
import List from '@/assets/svg/ico-list.svg';
import Logout from '@/assets/svg/ico-logout.svg';
import MagnifyingGlass from '@/assets/svg/ico-magnifying-glass.svg';
import Map from '@/assets/svg/ico-map.svg';
import Mark from '@/assets/svg/ico-mark.svg';
import MobFilters from '@/assets/svg/ico-mob-filters.svg';
import Money from '@/assets/svg/ico-money.svg';
import PaperPlane from '@/assets/svg/ico-paper-plane.svg';
import Paperclip from '@/assets/svg/ico-paperclip.svg';
import PdfFile from '@/assets/svg/ico-pdf-file.svg';
import Pen from '@/assets/svg/ico-pen.svg';
import Plus from '@/assets/svg/ico-plus.svg';
import Profile from '@/assets/svg/ico-profile.svg';
import QuoteLeft from '@/assets/svg/ico-quote-left.svg';
import QuoteRight from '@/assets/svg/ico-quote-right.svg';
import Residential from '@/assets/svg/ico-residential.svg';
import Right from '@/assets/svg/ico-right.svg';
import Ruler from '@/assets/svg/ico-ruler.svg';
import Save from '@/assets/svg/ico-save.svg';
import Searchbig from '@/assets/svg/ico-searchbig.svg';
import Size from '@/assets/svg/ico-size.svg';
import Star from '@/assets/svg/ico-star.svg';
import TimesSm from '@/assets/svg/ico-times-sm.svg';
import Times from '@/assets/svg/ico-times.svg';
import TrashBorder from '@/assets/svg/ico-trash-border.svg';
import Trash from '@/assets/svg/ico-trash.svg';
import Undo from '@/assets/svg/ico-undo.svg';
import UserClasic from '@/assets/svg/ico-user-clasic.svg';
import UserFull from '@/assets/svg/ico-user-full.svg';
import UserLight from '@/assets/svg/ico-user-light.svg';
import UserNew from '@/assets/svg/ico-user-new.svg';
import User from '@/assets/svg/ico-user.svg';
import Users from '@/assets/svg/ico-users.svg';

export default {
	props: {
		iconName: {
			type: String,
			required: true
		}
	},
	components: {
		Admin,
		Agent,
		AngleDown,
		ArchiveBorder,
		ArchiveFilled,
		Arhive,
		ArrowDown,
		ArrowL,
		ArrowLeft,
		ArrowRight,
		ArrowUp,
		Bell,
		Building,
		Buildings,
		CalendarDays,
		Calendar,
		Checked,
		ChevronDown,
		CircleDollar,
		ClipboardList,
		CloseIcon,
		CloseSm,
		Close,
		Cog,
		Commercial,
		Copy,
		Customers,
		Delete,
		Dolar,
		DollarSign,
		Dots,
		Edit,
		Ellipsis,
		Email,
		ExclamationCircle,
		ExclamationLight,
		ExclamationMark,
		ExclamationRegular,
		Exclamation,
		Eye,
		Eyeslash,
		File,
		Filters,
		Gallery,
		Grid,
		Happy,
		Home,
		ImgBig,
		Img,
		List,
		Logout,
		MagnifyingGlass,
		Map,
		Mark,
		MobFilters,
		Money,
		PaperPlane,
		Paperclip,
		PdfFile,
		Pen,
		Plus,
		Profile,
		QuoteLeft,
		QuoteRight,
		Residential,
		Right,
		Ruler,
		Save,
		Searchbig,
		Size,
		Star,
		TimesSm,
		Times,
		TrashBorder,
		Trash,
		Undo,
		UserClasic,
		UserFull,
		UserLight,
		UserNew,
		User,
		Users
	},
	computed: {
		component() {
			return _startcase(this.iconName.replace('ico-', '')).replace(' ', '');
		}
	}
};
</script>
